<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="3">
					<!-- 품번 -->
					<search-input
						:label="getMessage_('QWCC000956') + ' / ' + getMessage_('QWCC000957')"
						paramKey="partNm"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="searchParams.partNm"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPartPopup"></i></template>
					</search-input>
				</el-col>
				<!-- 변경번호 -->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC000006')"
						paramKey="altrNo"
						@commInput="setSearchParam"
						:clearable="true"
						:propData="searchParams.altrNo"
					>
					</search-input>
				</el-col>
				<!-- 협력사 -->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC000958')"
						paramKey="cofNm"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="searchParams.cofNm"
						:readonly="!(isPqyAdmin || isPqyManager || isPqyStaff)"
						:iconReadonly="!(isPqyAdmin || isPqyManager || isPqyStaff)"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPqyCpnyPopup"></i></template>
					</search-input>
				</el-col>
				<!-- 진행상태 -->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001094')"
						paramKey="pgsStEmCd"
						:options="pgsStEmCdList"
						:propData="searchParams.pgsStEmCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!-- 변경일자 -->
				<el-col :span="4">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001742') }}</span>
						<el-date-picker
							v-model="searchDateRange"
							type="daterange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
						/>
					</div>
				</el-col>
				<!-- ISIR 승인구분 -->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC000028')"
						paramKey="isirCsetScnCd"
						:options="getIsirCsetScnCdList2_"
						:propData="searchParams.isirCsetScnCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
		<!-- 팝업추가 영역 -->
		<part-mng-popup ref="partMngPopup" @SendData="sendData" :scrId="scrId"></part-mng-popup>
		<comp-popup ref="compPopup" @SendData="qpyCpnyData" :scrId="scrId"></comp-popup>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import SelectCombo from '@qms/Components/SelectCombo';
import PartMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';
import CompPopup from '@qms/comm/commpopup/CompPopup/CompPopup.vue';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return { searchDateRange: [] };
	},
	components: { SearchInput, SelectCombo, PartMngPopup, CompPopup },
	async created() {
		try {
			this.searchDateRange = [...this.getSearchDates_];
			await this.getCommCodesOnce_();
			await this.getCommCodes_({ key: 'isirCsetScnCdList2', codeType: 'ISIR_CSET_SCN' }); //ISIR
			await this.searchList();
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error?.message || error });
		}
	},
	watch: {
		searchDateRange(newValue) {
			if (newValue == null) {
				this.setSearchParam_({ key: 'strDt', value: '' });
				this.setSearchParam_({ key: 'endDt', value: '' });
			}
			if (newValue?.length == 2) {
				const strDt = this.$moment(this.searchDateRange[0]).format('YYYYMMDD');
				const endDt = this.$moment(this.searchDateRange[1]).format('YYYYMMDD');
				this.setSearchParam_({ key: 'strDt', value: strDt });
				this.setSearchParam_({ key: 'endDt', value: endDt });
			}
		}
	},
	methods: {
		...rootMethods,
		...qmsMethods,
		...serviceMethods,
		setSearchParam(param) {
			if (param.key === 'cofNm') {
				this.setSearchParam_({ key: 'cofCd', value: '' });
			}
			if (param.key === 'partNm') {
				this.setSearchParam_({ key: 'partNo', value: '' });
			}
			this.setSearchParam_(param);
		},
		onPartPopup() {
			this.$refs.partMngPopup.open(this.searchParams.partNm, {
				cpnyCd: this.searchParams.cofCd,
				cpnyNm: this.searchParams.cofNm,
				isDisabled: this.isPqyGuest ? 'Y' : 'N'
			});
		},
		//협력사조회 팝업
		onPqyCpnyPopup() {
			let params = {
				cpnyScn: '10',
				cpnyCd: this.searchParams.cofCd
			};
			this.$refs.compPopup.open(params);
		},
		async searchList() {
			try {
				const isEo4mInnerUser = !!(this.isPqyAdmin || this.isPqyManager || this.isPqyStaff);
				if (!isEo4mInnerUser && this.isPqyGuest) {
					const { cpnyCd, cpnyNm, partnerYn } = await this.getPartnerInfo_();
					if (!partnerYn || partnerYn === 'N')
						throw new Error(this.getMessage_('QWCC001885')); //사용자의 업체 정보를 불러올 수 없습니다. 관리자에게 문의하세요.
					else {
						this.setSearchParam_({ key: 'cofCd', value: cpnyCd });
						this.setSearchParam_({ key: 'cofNm', value: cpnyNm });
					}
				}
				this.$sf_toggleLoading(true);
				await this.getList_();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		sendData(row) {
			this.setSearchParam_({ key: 'partNo', value: row.partNo });

			let partNm = row.chPartNm;
			if (this.langCd == 'en_US') partNm = row.enPartNm;
			if (this.langCd == 'ko_KR') partNm = row.koPartNm;
			this.setSearchParam_({ key: 'partNm', value: partNm });
		},
		qpyCpnyData({ cpnyCd, cpnyNm }) {
			this.setSearchParam_({ key: 'cofCd', value: cpnyCd });
			this.setSearchParam_({ key: 'cofNm', value: cpnyNm });
		}
	},
	computed: { ...rootComputed, ...qmsComputed, ...serviceComputed }
};
</script>

<style></style>
